import { paramCase } from 'param-case';
import commonStyles from '../styles/commonStyles';

export default function (props) {
  if (props.className) {
    const classList = props.className ? props.className.split(' ') : [];
    const merged = classList.reduce((list, key) => {
      if (commonStyles[key]) {
        return { ...list, ...commonStyles[key] };
      }
      return { ...list };
    }, {});

    return Object.keys(merged).map((key) => {
      const parmaKey = paramCase(key);
      return `${parmaKey}: ${merged[key]};`;
    });
  }
}
